export interface ResponseItem {
  side: string;
  who: string;
  stance: string;
  points: string[];
}

export default function ResponseCompare({ items }: { items: ResponseItem[] }) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {items.map((item, index) => (
        <article
          key={item.side}
          className={`flex flex-col rounded-lg border p-4 md:p-5 ${
            index === 0 ? "border-accent-200 bg-accent-50/60" : "border-primary-200 bg-primary-50/60"
          }`}
        >
          <header>
            <p
              className={`text-[11px] font-medium tracking-widest ${
                index === 0 ? "text-accent-700" : "text-primary-700"
              }`}
            >
              {item.side}
            </p>
            <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">{item.who}</h3>
            <p className="mt-2 rounded-md bg-background-50/80 px-3 py-2 text-xs leading-relaxed text-foreground-700">
              <span className="font-medium">立场：</span>
              {item.stance}
            </p>
          </header>
          <ul className="mt-4 flex flex-col gap-2.5">
            {item.points.map((point) => (
              <li key={point} className="flex gap-2 text-sm leading-relaxed text-foreground-700">
                <i
                  className={`mt-1 text-sm ${
                    index === 0 ? "ri-chat-1-line text-accent-600" : "ri-chat-3-line text-primary-600"
                  }`}
                  aria-hidden="true"
                />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  );
}